import { render, staticRenderFns } from "./PayBoxUnknownError.vue?vue&type=template&id=461a8d13&"
import script from "./PayBoxUnknownError.vue?vue&type=script&lang=js&"
export * from "./PayBoxUnknownError.vue?vue&type=script&lang=js&"
import style0 from "./PayBoxUnknownError.vue?vue&type=style&index=0&id=461a8d13&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('461a8d13')) {
      api.createRecord('461a8d13', component.options)
    } else {
      api.reload('461a8d13', component.options)
    }
    module.hot.accept("./PayBoxUnknownError.vue?vue&type=template&id=461a8d13&", function () {
      api.rerender('461a8d13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-configuration/PayBoxUnknownError.vue"
export default component.exports